import React from 'react';
import * as S from './SearchPageSoldOut.styles';
import TimerIcon from '../../../../../stories/assets/hotels/details/timerIcon.svg';

const SearchPageSoldOut = () => (
  <S.SoldOutWrapperDiv>
    <S.SoldOutInnerDiv>
      {/* <S.TimerImage
        src={' https://gos3.ibcdn.com/soldoutimage-1579211801.png'}
        alt="Sold Out Icon"
      /> */}
      <S.IconWrapperSpan>
        <TimerIcon />
      </S.IconWrapperSpan>
      <S.SoldOutTextWrappDiv>
        <S.FirstTxtPara>Soldout! Your dates are very popular</S.FirstTxtPara>
        {/* <S.AlternateDateLink>Try Alternate Dates</S.AlternateDateLink> */}
      </S.SoldOutTextWrappDiv>
    </S.SoldOutInnerDiv>
  </S.SoldOutWrapperDiv>
);

export default SearchPageSoldOut;
